"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Sheet = Sheet;
exports.SheetClose = SheetClose;
exports.SheetContent = SheetContent;
exports.SheetDescription = SheetDescription;
exports.SheetFooter = SheetFooter;
exports.SheetHeader = SheetHeader;
exports.SheetTitle = SheetTitle;
exports.SheetTrigger = SheetTrigger;
var React = _interopRequireWildcard(require("react"));
var _utils = require("@design/lib/utils");
var _focusAutofocusField = require("@design/lib/focus-autofocus-field");
var _radixUi = require("radix-ui");
var _closeButton = require("@design/ui/close-button");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["className"],
  _excluded2 = ["className", "children", "side", "showCloseButton", "onOpenAutoFocus"],
  _excluded3 = ["className"],
  _excluded4 = ["className"],
  _excluded5 = ["className"],
  _excluded6 = ["className"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectDestructuringEmpty(t) { if (null == t) throw new TypeError("Cannot destructure " + t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function Sheet(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_radixUi.Dialog.Root, _objectSpread(_objectSpread({
    "data-slot": "sheet"
  }, props), {}, {
    "data-sentry-element": "SheetPrimitive.Root",
    "data-sentry-component": "Sheet",
    "data-sentry-source-file": "sheet.tsx"
  }));
}
function SheetTrigger(_ref2) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref2), _ref2));
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_radixUi.Dialog.Trigger, _objectSpread(_objectSpread({
    "data-slot": "sheet-trigger"
  }, props), {}, {
    "data-sentry-element": "SheetPrimitive.Trigger",
    "data-sentry-component": "SheetTrigger",
    "data-sentry-source-file": "sheet.tsx"
  }));
}
function SheetClose(_ref3) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref3), _ref3));
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_radixUi.Dialog.Close, _objectSpread(_objectSpread({
    "data-slot": "sheet-close"
  }, props), {}, {
    "data-sentry-element": "SheetPrimitive.Close",
    "data-sentry-component": "SheetClose",
    "data-sentry-source-file": "sheet.tsx"
  }));
}
function SheetPortal(_ref4) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref4), _ref4));
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_radixUi.Dialog.Portal, _objectSpread(_objectSpread({
    "data-slot": "sheet-portal"
  }, props), {}, {
    "data-sentry-element": "SheetPrimitive.Portal",
    "data-sentry-component": "SheetPortal",
    "data-sentry-source-file": "sheet.tsx"
  }));
}
function SheetOverlay(_ref5) {
  var className = _ref5.className,
    props = _objectWithoutProperties(_ref5, _excluded);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_radixUi.Dialog.Overlay, _objectSpread(_objectSpread({
    "data-slot": "sheet-overlay",
    className: (0, _utils.cn)("fixed inset-0 z-modal bg-black/10 duration-100 supports-backdrop-filter:backdrop-blur-xs data-open:animate-in data-open:fade-in-0 data-closed:animate-out data-closed:fade-out-0", className)
  }, props), {}, {
    "data-sentry-element": "SheetPrimitive.Overlay",
    "data-sentry-component": "SheetOverlay",
    "data-sentry-source-file": "sheet.tsx"
  }));
}
function SheetContent(_ref6) {
  var className = _ref6.className,
    children = _ref6.children,
    _ref6$side = _ref6.side,
    side = _ref6$side === void 0 ? "right" : _ref6$side,
    _ref6$showCloseButton = _ref6.showCloseButton,
    showCloseButton = _ref6$showCloseButton === void 0 ? true : _ref6$showCloseButton,
    onOpenAutoFocus = _ref6.onOpenAutoFocus,
    props = _objectWithoutProperties(_ref6, _excluded2);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(SheetPortal, {
    "data-sentry-element": "SheetPortal",
    "data-sentry-component": "SheetContent",
    "data-sentry-source-file": "sheet.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(SheetOverlay, {
      "data-sentry-element": "SheetOverlay",
      "data-sentry-source-file": "sheet.tsx"
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_radixUi.Dialog.Content, _objectSpread(_objectSpread({
      "data-slot": "sheet-content",
      onOpenAutoFocus: (0, _focusAutofocusField.focusAutofocusFieldOnOpen)(onOpenAutoFocus),
      "data-side": side,
      className: (0, _utils.cn)("fixed z-modal flex flex-col gap-4 bg-background-card bg-clip-padding p-(--component-sheet-padding) text-sm text-popover-foreground shadow-md outline-none transition duration-200 ease-in-out data-[side=bottom]:inset-x-0 data-[side=bottom]:bottom-0 data-[side=bottom]:h-auto data-[side=bottom]:rounded-t-lg data-[side=bottom]:border-t data-[side=left]:inset-y-0 data-[side=left]:left-0 data-[side=left]:h-full data-[side=left]:w-3/4 data-[side=left]:border-r data-[side=right]:inset-y-0 data-[side=right]:right-0 data-[side=right]:h-full data-[side=right]:w-3/4 data-[side=right]:border-l data-[side=top]:inset-x-0 data-[side=top]:top-0 data-[side=top]:h-auto data-[side=top]:border-b data-[side=left]:sm:max-w-(--sheet-width-default) data-[side=right]:sm:max-w-(--sheet-width-default) data-open:animate-in data-open:fade-in-0 data-[side=bottom]:data-open:slide-in-from-bottom-10 data-[side=left]:data-open:slide-in-from-left-10 data-[side=right]:data-open:slide-in-from-right-10 data-[side=top]:data-open:slide-in-from-top-10 data-closed:animate-out data-closed:fade-out-0 data-[side=bottom]:data-closed:slide-out-to-bottom-10 data-[side=left]:data-closed:slide-out-to-left-10 data-[side=right]:data-closed:slide-out-to-right-10 data-[side=top]:data-closed:slide-out-to-top-10", className)
    }, props), {}, {
      "data-sentry-element": "SheetPrimitive.Content",
      "data-sentry-source-file": "sheet.tsx",
      children: [children, showCloseButton && /*#__PURE__*/(0, _jsxRuntime.jsx)(_radixUi.Dialog.Close, {
        "data-slot": "sheet-close",
        asChild: true,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_closeButton.CloseButton, {
          className: "absolute top-3 right-3 size-4 rounded-sm"
        })
      })]
    }))]
  });
}
function SheetHeader(_ref7) {
  var className = _ref7.className,
    props = _objectWithoutProperties(_ref7, _excluded3);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", _objectSpread(_objectSpread({
    "data-slot": "sheet-header",
    className: (0, _utils.cn)("flex flex-col gap-4 p-2", className)
  }, props), {}, {
    "data-sentry-component": "SheetHeader",
    "data-sentry-source-file": "sheet.tsx"
  }));
}
function SheetFooter(_ref8) {
  var className = _ref8.className,
    props = _objectWithoutProperties(_ref8, _excluded4);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", _objectSpread(_objectSpread({
    "data-slot": "sheet-footer",
    className: (0, _utils.cn)("mt-auto flex flex-row justify-end gap-2 p-4", className)
  }, props), {}, {
    "data-sentry-component": "SheetFooter",
    "data-sentry-source-file": "sheet.tsx"
  }));
}
function SheetTitle(_ref9) {
  var className = _ref9.className,
    props = _objectWithoutProperties(_ref9, _excluded5);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_radixUi.Dialog.Title, _objectSpread(_objectSpread({
    "data-slot": "sheet-title",
    className: (0, _utils.cn)("text-lg leading-5 font-medium text-foreground", className)
  }, props), {}, {
    "data-sentry-element": "SheetPrimitive.Title",
    "data-sentry-component": "SheetTitle",
    "data-sentry-source-file": "sheet.tsx"
  }));
}
function SheetDescription(_ref0) {
  var className = _ref0.className,
    props = _objectWithoutProperties(_ref0, _excluded6);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_radixUi.Dialog.Description, _objectSpread(_objectSpread({
    "data-slot": "sheet-description",
    className: (0, _utils.cn)("text-sm text-muted-foreground", className)
  }, props), {}, {
    "data-sentry-element": "SheetPrimitive.Description",
    "data-sentry-component": "SheetDescription",
    "data-sentry-source-file": "sheet.tsx"
  }));
}